import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from '../../../services/login.service';

@Component({
  selector: 'app-verify-otp',
  templateUrl: './verify-otp.component.html',
  styleUrl: './verify-otp.component.scss'
})
export class VerifyOtpComponent {

  displayResendCode: boolean = false;
  interval: any = null;
  otp: any;
  modalData: any;
  errorMsgs: any;


  constructor(
    public dialogRef: MatDialogRef<VerifyOtpComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private loginService: LoginService,
    private toastrService: ToastrService,
    private translate: TranslateService
  ) {
    this.modalData = data;
    translate.get(['toasterStatus']).subscribe(data => {
      this.errorMsgs = data;
    })
  }

  ngOnInit() {
    setTimeout(() => {
      var fiveMinutes = 60 * 2,
        display = document.querySelector('#time');
      this.timer(fiveMinutes, display);
    }, 100)

  }

  timer(duration: any, display: any) {
    let self = this;
    var timer = 60 * 2, diff, minutes, seconds;
    var start = Date.now()
    if (self.interval !== null) {
      clearInterval(self.interval);
    }

    self.interval = setInterval(function () {
      diff = duration - (((Date.now() - start) / 1000) | 0);
      minutes = (diff / 60) | 0;
      seconds = (diff % 60) | 0;

      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      display.textContent = minutes + ":" + seconds;

      if (--timer < 0) {
        self.displayResendCode = true;
        timer = duration;
        display.textContent = '';
      }
    }, 1000);

    setTimeout(() => {
      clearInterval(self.interval);
      self.displayResendCode = true;
      timer = duration;
      display.textContent = '';
    }, 120000);
  }

  onOtpChange(otp: any) {
    this.otp = otp;
  }

  verifyOtp() {
    let body1 = {
      "tokenType": "WebLogin",
      "otpCode": this.otp
    }
    this.loginService.verifyOtpToken(body1).subscribe((data: any) => {
      if (data && data.status && data.status.isSuccess) {
        this.dialogRef.close(this.otp);
      }
      else {
        // localStorage.removeItem('authToken');
        this.toastrService.error(data.status.statusMessage, this.errorMsgs['toasterStatus'].error)
      }
    })
  }

  cancelClick(event: any) {
    this.dialogRef.close();
    event.stopPropagation();
  }

  resendClick() {
    // let body = {
    //   "tokenType": "WebLogin",
    //   "phoneNumber": this.modalData.mobileNumber,
    // }
    // this.loginService.sendMobileOtp(body).subscribe((res: any) => {
    //   if (res && res.status && res.status.isSuccess) {
    let body1 = {
      "tokenType": "WebLogin",
      "phoneNumber": this.modalData.mobileNumber,
      "emailAddress": this.modalData.email
    }
    this.loginService.sendMobileAndEmailOtp(body1).subscribe((res1: any) => {
      if (res1 && res1.status && res1.status.isSuccess) {
        this.displayResendCode = false;
        setTimeout(() => {
          var fiveMinutes = 60 * 2,
            display = document.querySelector('#time');
          this.timer(fiveMinutes, display);
        }, 100);
        this.toastrService.success(res1.status.statusMessage, this.errorMsgs['toasterStatus'].success);
      }
      else {
        this.toastrService.error(res1.status.statusMessage, this.errorMsgs['toasterStatus'].error);
      }
    })
    // }
    //   else {
    //     this.toastrService.error(res.status.statusMessage, this.errorMsgs['toastrStatus'].error);
    //   }
    // })
  }

  displayEmail(email: string) {
    // let emailArray = email.split('.');
    // let emailLenght = emailArray[0].length;
    // let newEmail :string = email.charAt(0) + email.concat('')  
    let at = email.indexOf(".")
    return email[0]
      + email.substring(1, at).replace(/./g, "•")
      + email.substring(at, email.length)
  }

  displayMobile(mobile: string) {
    return mobile.substring(0, mobile.length - 4).replace(/./g, "•") + mobile.substr(mobile.length - 4, 4);
  }
}
